//#region Libraries
import styled from "styled-components";
//#endregion
import { TDefContent } from "components/CustomTableList/components/TableListItem/ListItem/styles";

export const NameCell = styled(TDefContent)`
    min-width: 135px;
    & h5 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        padding: 0;
        width: 100%;
    }

`;
export const UserCell = styled(NameCell)`
    border-radius: 4px;
    border-left: 8px solid transparent;
    &.active {
        border-left-color: var(--light-gray-4);
    }
    &.created-or-updated {
        border-left-color: var(--red-1);
    }
`;
export const RoleCell = styled(TDefContent)`
    min-width: 160px;
    & h5 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        padding: 0 5px;
        width: 100%;
    }
`;
export const CategoryCell = styled(TDefContent)`
    min-width: 130px;
    & h5 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        padding: 0 5px;
        width: 100%;
    }
`;